import React, { forwardRef, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';
import { Popover } from '@headlessui/react';
import SelectMenuContext from './SelectMenuContext';

// eslint-disable-next-line react/prop-types
const Label = ({ multiple, children, ...props }) =>
  multiple ? (
    // eslint-disable-next-line
    <label {...props}>{children}</label>
  ) : (
    // Popover Button automatically closes panel when clicked
    // eslint-disable-next-line
    <Popover.Button as="label" {...props}>
      {children}
    </Popover.Button>
  );

const SelectMenuItem = forwardRef(({ value, label, name, onChange }, ref) => {
  const { multiple } = useContext(SelectMenuContext);

  const inputClassNames = useClassNames(
    () => (multiple ? ['form-checkbox', 'h-4', 'w-4', 'rounded border-1'] : ['hidden']),
    [multiple],
  );

  const labelClassNames = useClassNames(
    () => ['whitespace-nowrap', multiple && 'ml-3'],
    [multiple],
  );

  const createOnChangeHandler = useCallback(
    value => () => {
      if (onChange) onChange(value);
    },
    [onChange],
  );

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <Label multiple={multiple} className="flex items-center p-3 cursor-pointer hover:bg-slate-50">
      <input
        name={name}
        value={value}
        type={multiple ? 'checkbox' : 'radio'}
        ref={ref}
        className={inputClassNames}
        onChange={createOnChangeHandler(value)}
      />
      <span className={labelClassNames}>{label}</span>
    </Label>
  );
});

SelectMenuItem.propTypes = {
  // eslint-disable-next-line
  value: PropTypes.any,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  name: PropTypes.string,
  onChange: PropTypes.func,
};

SelectMenuItem.defaultProps = {
  value: null,
  label: null,
  name: null,
  onChange: () => {},
};

SelectMenuItem.defaultProps = {};

export default SelectMenuItem;
